import axios from 'axios';

const storagePath = '/storage/static/';

const getStoredLanguage = () => {
	if (typeof window === 'undefined' || !window.localStorage) {
		return null;
	}

	return window.localStorage.getItem('activeLanguage');
};

const pickValidLanguage = ({ preferred, languageList }) => {
	if (!Array.isArray(languageList) || languageList.length === 0) {
		return preferred || null;
	}

	const allowed = languageList.map(l => l.name);
	if (preferred && allowed.includes(preferred)) {
		return preferred;
	}

	const stored = getStoredLanguage();
	if (stored && allowed.includes(stored)) {
		return stored;
	}

	return allowed[0];
};

export default {
	namespaced: true,
	state: {
		storagePath,
		dataAvailable: false,
		backgrounds: [],
		allMenus: [],
		language: null,
		languageList: [],
		categories: [],
		// @TODO hardcoded value right now, no API endpoint
		homePage: 1,
		generalSettings: null,
	},
	mutations: {
		updateDataStatus(state, newValue) {
			state.dataAvailable = newValue;
		},
		updateMenus(state, menuArray) {
			state.allMenus = menuArray;
		},
		updateLanguage(state, lang) {
			state.language = lang;
		},
		updateLanguageList(state, langList) {
			state.languageList = langList;
		},
		updateCategories(state, catgs) {
			state.categories = catgs;
		},
		updateBackgrounds(state, bckgs) {
			state.backgrounds = bckgs;
		},
		updateGeneralSettings(state, genSet) {
			state.generalSettings = genSet;
		},
	},
	actions: {
		fetchMenus({ commit }) {
			return axios.get('/api/menus')
				.then(result => commit('updateMenus', result.data))
				.catch();
		},
		fetchLanguageData({ commit }) {
			return Promise.all([
				axios.get('/api/language'),
				axios.get('/api/language-list'),
			])
				.then(([languageResult, languageListResult]) => {
					const languageList = languageListResult.data;
					commit('updateLanguageList', languageList);
					const lang = pickValidLanguage({ preferred: languageResult.data, languageList });
					commit('updateLanguage', lang);
				})
				.catch();
		},
		fetchCategories({ commit }) {
			return axios.get('/api/categories')
				.then(result => commit('updateCategories', result.data))
				.catch();
		},
		fetchBackgrounds({ commit }) {
			return axios.get('/api/background-gallery')
				.then(result => commit('updateBackgrounds', result.data))
				.catch();
		},
		fetchGeneralSettings({ commit }) {
			return axios.get('/api/gen-settings')
				.then(result => commit('updateGeneralSettings', result.data))
				.catch();
		},
	},
	getters: {
		getAllMenus(state) {
			return state.allMenus;
		},
		getLanguage(state) {
			return state.language;
		},
		getLanguageList(state) {
			return state.languageList;
		},
		getCategories(state) {
			return state.categories;
		},
		getBackgrounds(state) {
			return state.backgrounds;
		},
		getGeneralSettings(state) {
			return state.generalSettings;
		},
	},
};
